export const userFieldKeysMap = new Map([
    ['marketing_consent', 'Marketing Consent'],
    ['analytics_consent', 'Analytic Consent'],
    ['unit', 'Unit System'],
    ['windunit', 'Wind Speed'],
    ['pressureunit', 'Pressure'],
    ['feel_like_algo', 'Feels-like T°'],
    ['validated_mail', 'Validated Email'],
    ['privacy_policy', 'Privacy Policy'],
    ['terms_of_use', 'Terms of Use'],
    ['dev_terms_of_use', 'Dev Terms of Use'],
    ['profiling', 'Analytic Consent'],
    ['marketingCampaigns', 'Marketing Consent'],
    ['password_changed', 'Password Changed'],
    ['account_new_connection', 'Account New Connections'],
    ['account_too_many_connections', 'Account Too Many Connections'],
    ['thermostat_energy_bilan', 'Thermostat Bilan Energy'],
    ['thermostat_low_battery', 'Thermostat Low Battery'],
    ['givenName', 'Name'],
    ['surname', 'Surname'],
    ['phoneNumber', 'Phone Number'],
]);
